import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button, Popup } from "../index.ts"
import moment from 'moment-timezone';
import { formatUserDate, getUserDatePickerFormat, parseDateForPicker } from '../../utils';

const DateLabel = ({ value }) => {
  const className = !(value?.dateRange?.gte && value?.dateRange?.lte) && 'text-gray-800';

  return (
    <div className={`text-[12px] font-normal flex justify-between items-center w-full ${className}`}>
      <div>
        {formatUserDate(value?.dateRange?.gte) || 'From Date'} <b>-</b> {formatUserDate(value?.dateRange?.lte) || 'To Date'}
      </div>
      <div>
        {/* <IconCalendar color='#586071' size={20} /> */}
      </div>
    </div>
  );
};

export const DateRange = ({ value, onChange, className = '' }) => {
  const handleChange = (dates) => {
    const [start, end] = dates;

    onChange({
      ...value,
      dateRange: {
        ...value.dateRange,
        gte: start ? moment(start).format("YYYY-MM-DD") : null,
        lte: end ? moment(end).format("YYYY-MM-DD") : null,
      },
    });
  };

  return (
    <Popup
      alignRight={true}
      className={`p-1 bp-0`}
      component={() => (
        <Button
          label={<DateLabel value={value} />}
          action='outline'
          className={`px-2 bg-transparent border border-gray-800 min-w-[200px] normal-case justify-between ${className}`}
        />
      )}
      content={({ close }) => (
        <DatePicker
          selected={null}
          swapRange
          startDate={parseDateForPicker(value?.dateRange?.gte)}
          endDate={parseDateForPicker(value?.dateRange?.lte)}
          onChange={handleChange}
          selectsRange
          selectsDisabledDaysInRange
          inline
          dateFormat={getUserDatePickerFormat()}
        />
      )}
    />
  );
};
